import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetCompanyTaskDefinitionsRequestSchema } from "./getCompanyTaskDefinitions.schema";

export const getCompanyTaskDefinitions = (axios: IAxiosInstance) => {
  return async (companyId: string) => {
    const response = await axios.noRetry.get<
      ZealApiResponse<TGetCompanyTaskDefinitionsRequestSchema>
    >(`/company/${companyId}/tasks/definitions`);
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
